// const BACKEND_API = `http://35.240.165.86:8000/api`
// const BACKEND_API = `https://api.journalplatform.com/api`
const BACKEND_API = `https://api.ieltsngocbach.com/api`
// const BACKEND_API = process.env.VUE_APP_ROOT_API


const OXFORD = {
    LOOKUP: `${BACKEND_API}/lookup/oxford?word={word}`
}

export {OXFORD}

